import { Component, OnInit, ViewChild, ElementRef, HostBinding, EventEmitter, Input, Output } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, tap, switchMap } from 'rxjs/operators';
import { GeocodeService } from 'src/app/services/geocode.service';
import { NgbTypeahead, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
// @ts-ignore
import { LngLat, LngLatBounds } from '!mapbox-gl';
import { Decorable } from 'src/app/types/decorable';
import { SLMap } from 'src/app/model/sl-map';
import { SimpleTHandler, DictHandler } from 'src/app/types/@types/sl-v-types';

export type StreetInputParams = {
  autoComplete: boolean;
  limitExtents: boolean;
  bbox?: [number, number, number, number];
}

@Component({
  selector: 'app-street-input',
  templateUrl: './street-input.component.html',
  styleUrls: ['./street-input.component.scss']
})
export class StreetInputComponent implements OnInit {
  public model: any = {};
  public searching = false;
  public searchFailed = false;
  private _value: Decorable = {};
  @Input()
  public set value(val: Decorable) {
    if (val === this._value) return;
    if (!!val && Object.keys(val).length === 0) return;
    this._value = val;
    this.valueChange.emit(this._value);
  }
  public get value(): Decorable {
    return this._value;
  }

  @Output() valueChange = new EventEmitter<Decorable>();

  @Input()
  public GetParameterSrc: SimpleTHandler<StreetInputParams> | undefined;

  private map: SLMap;
  private okHandler: DictHandler;
  public attribution = '';
  private isActive: boolean = false;

  @HostBinding('class.active') set active(isActive: boolean) {
    isActive = isActive;
    if (this.isActive === true) {
      (this.locSearchGroup.nativeElement.getElementsByClassName('loc-search')[0] as HTMLElement).focus();
    }
  };
  @ViewChild('locSearchGrp', { static: true }) locSearchGroup: ElementRef<HTMLDivElement>;
  @ViewChild(NgbTypeahead, { static: true }) locSearch: NgbTypeahead;
  @ViewChild('extentsCB', { static: true }) extentsCB: ElementRef;
  @ViewChild('form', { static: true }) form: ElementRef;


  constructor(private service: GeocodeService, private domNode: ElementRef) { }

  private _params: StreetInputParams = {
    autoComplete: true,
    limitExtents: false
  }
  get params(): StreetInputParams {
    return this._params;
  }
  ngOnInit(): void {
  }
  public search = (textObs: Observable<string>) =>
    textObs.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      tap(() => {
        this.searching = true;
        this._params = (!!this.GetParameterSrc) ? this.GetParameterSrc() : { autoComplete: true, limitExtents: false }
      }),
      switchMap(term =>
        this.service.search(term, this._params).pipe(
          tap(() => {
            this.searchFailed = false;
            // this.value = { autoComplete: params.autoComplete, limitToExtents: params.limitExtents };
          }),
          catchError(() => {
            this.searchFailed = true;
            // this.value = { autoComplete: params.autoComplete, limitToExtents: params.limitExtents };
            return of([]);

          }))
      ),
      tap(() => {

        this.searching = false;
        // this.valueChange.emit(this.value);
      })
    );
  public Setup() {
    const elements = (this.domNode.nativeElement as HTMLElement).getElementsByClassName('loc-search')
    if (elements.length > 0) {
      elements[0].setAttribute('title', this.attribution);
    }
    const locSearchElement = elements[0]!;
    this.locSearch.selectItem.subscribe((event: NgbTypeaheadSelectItemEvent) => {
      this.attribution = this.service.lastResults.attribution;
      locSearchElement!.setAttribute('title', this.attribution);

      this.value = event.item;
      if (event.item.hasOwnProperty('bbox')) {
        this.value.bbox = event.item.bbox;
      } else {
        this.value.point = new LngLat(event.item.center[0], event.item.center[1]);
      }
      this.valueChange.emit(this.value);
    });
    (locSearchElement as HTMLInputElement).addEventListener('keyup', (event: any) => {
      switch (event.keyCode) {
        case 13:
          if (this.okHandler) {
            this.okHandler(this.value);

          }
          break;
      }
    });
  }
  public formatter(x: { name: string }) {
    return (x as any).place_name;
  };

}
